const opInScreen = () => {
	let options = {
		root: null,
		rootMargin: "0px",
		threshold: 0.2,
	};
	let observer = new IntersectionObserver((entries, observer) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				entry.target.classList.add("show");
				observer.unobserve(entry.target);
			} else {
				return;
			}
		});
	}, options);

	let targets = document.querySelectorAll(".op-inScreen");
	targets.forEach((target) => {
		observer.observe(target);
	});
};

export default opInScreen;
